var _defs, _g, _g2, _path, _g3, _g4, _path2, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrystalisation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 649.09283,
    height: 748.27429,
    viewBox: "0 0 649.09283 748.27429",
    xmlSpace: "preserve",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    id: "svg3882",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Crystallisation",
    transform: "matrix(0.829192,0,0,1.09268,-553.1633,-2033.8551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer1",
    transform: "matrix(1.20599,0,0,0.915179,-457.841,170.765)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967103,0,0,0.888305,43.8825,293.949)",
    id: "g3714"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.781101,0,0,1.37199,-2815.67,374.092)",
    id: "g3700"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5211.1299,
    cy: 1555.84,
    rx: 429.629,
    ry: 59.991001,
    id: "ellipse3696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5211.13,1495.85 c 237.11,0 429.63,26.88 429.63,59.99 0,33.11 -192.52,59.99 -429.63,59.99 -237.12,0 -429.63,-26.88 -429.63,-59.99 0,-33.11 192.51,-59.99 429.63,-59.99 z m 0,2.09 c 165.39,0 309.02,13.07 380.3,32.26 14.92,4.01 26.62,8.28 34.56,12.77 7.33,4.15 11.4,8.42 11.4,12.87 0,4.46 -4.07,8.73 -11.4,12.87 -7.94,4.49 -19.64,8.76 -34.56,12.78 -71.28,19.19 -214.91,32.26 -380.3,32.26 -165.4,0 -309.02,-13.07 -380.31,-32.26 -14.92,-4.02 -26.61,-8.29 -34.56,-12.78 -7.33,-4.14 -11.4,-8.41 -11.4,-12.87 0,-4.45 4.07,-8.72 11.4,-12.87 7.95,-4.49 19.64,-8.76 34.56,-12.77 71.29,-19.19 214.91,-32.26 380.31,-32.26 z",
    id: "path3698"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.976266,0,0,0.487998,-3494.11,1796.34)",
    id: "g3706"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4520.5601,
    y: 1413.55,
    width: 687.48401,
    height: 58.701,
    id: "rect3702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5208.05,1413.55 h -687.49 v 58.7 h 687.49 z m -2.69,5.86 v 46.97 c 0,0 -635.53,0 -682.11,0 0,0 0,-46.97 0,-46.97 0,0 682.11,0 682.11,0 z",
    id: "path3704"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.781101,0,0,1.37199,-2815.67,349.412)",
    id: "g3712"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5211.1299,
    cy: 1555.84,
    rx: 429.629,
    ry: 59.991001,
    style: {
      fill: "#ffffff"
    },
    id: "ellipse3708"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 5211.13,1495.85 c 237.11,0 429.63,26.88 429.63,59.99 0,33.11 -192.52,59.99 -429.63,59.99 -237.12,0 -429.63,-26.88 -429.63,-59.99 0,-33.11 192.51,-59.99 429.63,-59.99 z m 0,2.09 c 165.39,0 309.02,13.07 380.3,32.26 14.92,4.01 26.62,8.28 34.56,12.77 7.33,4.15 11.4,8.42 11.4,12.87 0,4.46 -4.07,8.73 -11.4,12.87 -7.94,4.49 -19.64,8.76 -34.56,12.78 -71.28,19.19 -214.91,32.26 -380.3,32.26 -165.4,0 -309.02,-13.07 -380.31,-32.26 -14.92,-4.02 -26.61,-8.29 -34.56,-12.78 -7.33,-4.14 -11.4,-8.41 -11.4,-12.87 0,-4.45 4.07,-8.72 11.4,-12.87 7.95,-4.49 19.64,-8.76 34.56,-12.77 71.29,-19.19 214.91,-32.26 380.31,-32.26 z",
    id: "path3710"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.848457,0,0,0.848457,192.753,345.021)",
    id: "g3734"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.781101,0,0,1.37199,-2815.67,402.013)",
    id: "g3720"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5211.1299,
    cy: 1555.84,
    rx: 429.629,
    ry: 59.991001,
    id: "ellipse3716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5211.13,1495.85 c 237.11,0 429.63,26.88 429.63,59.99 0,33.11 -192.52,59.99 -429.63,59.99 -237.12,0 -429.63,-26.88 -429.63,-59.99 0,-33.11 192.51,-59.99 429.63,-59.99 z m 0,2.19 c 165.26,0 308.78,13.04 380,32.22 14.86,4 26.51,8.25 34.43,12.72 7.31,4.14 11.36,8.41 11.36,12.86 0,4.45 -4.05,8.73 -11.36,12.86 -7.92,4.48 -19.57,8.73 -34.43,12.73 -71.22,19.18 -214.74,32.22 -380,32.22 -165.27,0 -308.78,-13.04 -380.01,-32.22 -14.86,-4 -26.51,-8.25 -34.43,-12.73 -7.31,-4.13 -11.36,-8.41 -11.36,-12.86 0,-4.45 4.05,-8.72 11.36,-12.86 7.92,-4.47 19.57,-8.72 34.43,-12.72 71.23,-19.18 214.74,-32.22 380.01,-32.22 z",
    id: "path3718"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.976266,0,0,1,-3494.11,1070.46)",
    id: "g3726"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4520.5601,
    y: 1413.55,
    width: 687.48401,
    height: 58.701,
    id: "rect3722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5208.05,1413.55 h -687.49 v 58.7 h 687.49 z m -3.07,2.99 v 52.71 c 0,0 -631.85,0 -681.35,0 0,0 0,-52.71 0,-52.71 0,0 681.35,0 681.35,0 z",
    id: "path3724"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.781101,0,0,1.37199,-2815.67,349.412)",
    id: "g3732"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5211.1299,
    cy: 1555.84,
    rx: 429.629,
    ry: 59.991001,
    style: {
      fill: "#ffffff"
    },
    id: "ellipse3728"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 5211.13,1495.85 c 237.11,0 429.63,26.88 429.63,59.99 0,33.11 -192.52,59.99 -429.63,59.99 -237.12,0 -429.63,-26.88 -429.63,-59.99 0,-33.11 192.51,-59.99 429.63,-59.99 z m 0,2.19 c 165.26,0 308.78,13.04 380,32.22 14.86,4 26.51,8.25 34.43,12.72 7.31,4.14 11.36,8.41 11.36,12.86 0,4.45 -4.05,8.73 -11.36,12.86 -7.92,4.48 -19.57,8.73 -34.43,12.73 -71.22,19.18 -214.74,32.22 -380,32.22 -165.27,0 -308.78,-13.04 -380.01,-32.22 -14.86,-4 -26.51,-8.25 -34.43,-12.73 -7.31,-4.13 -11.36,-8.41 -11.36,-12.86 0,-4.45 4.05,-8.72 11.36,-12.86 7.92,-4.47 19.57,-8.72 34.43,-12.72 71.23,-19.18 214.74,-32.22 380.01,-32.22 z",
    id: "path3730"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0986,0,0,1.97443,386.949,-165.101)",
    id: "g3738"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 792.28497,
    cy: 1322.27,
    rx: 187.897,
    ry: 26.136,
    id: "ellipse3736"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.12332,0,0,1.12332,-4223.78,808.828)",
    id: "g3742"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 4879.4,924.438 c 157.68,0 285.7,128.022 285.7,285.702 0,157.69 -128.02,285.71 -285.7,285.71 -157.69,0 -285.71,-128.02 -285.71,-285.71 0,-157.68 128.02,-285.702 285.71,-285.702 z m 0,48.036 c 131.17,0 237.67,106.496 237.67,237.666 0,131.18 -106.5,237.68 -237.67,237.68 -131.18,0 -237.67,-106.5 -237.67,-237.68 0,-131.17 106.49,-237.666 237.67,-237.666 z",
    id: "path3740"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.866132,-0.0895894,0.0895894,0.866132,-3166.63,1679.56)",
    id: "g3746"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 4795.28,1356.03 -31.34,-208.81 60.06,-99.24 95.33,84.22 19.58,233.55 z",
    id: "path3744"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3625.27,1044.56)",
    id: "g3750"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 4941.13,1384.04 68.86,-345.58 -66.31,-142.818 -131.34,133.898 15.3,364.7 z",
    id: "path3748"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04908,0,0,1.03697,-3854.89,987.388)",
    id: "g3754"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 4900.28,1365.75 109.71,-158.42 57.59,-26.12 4.71,66.49 -77.81,132.18 z",
    id: "path3752"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3601.4,1070.46)",
    id: "g3758"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 4919.28,875.793 -120.08,130.427 90.83,66.61 80.46,-58.91 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3756"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3601.4,1070.46)",
    id: "g3762"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 4793.22,1006.22 12.48,135.59 72.02,103.01 12.31,-163.44 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3760"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3601.4,1070.46)",
    id: "g3766"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 4984.99,1013.92 -88.54,64 -13.32,171.94 35.32,40.85 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3764"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3601.4,1070.46)",
    id: "g3770"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 4709.57,1092.33 -39.17,80.63 106,44.04 11.08,-69.19 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3768"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3601.4,1070.46)",
    id: "g3774"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 4670.4,1176.4 35.37,133.68 150.87,29.03 -87.57,-108.32 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3772"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3601.4,1070.46)",
    id: "g3778"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 4793,1155.86 -12.41,63.79 80.64,118.38 98.62,5.82 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3776"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3601.4,1070.46)",
    id: "g3782"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 5060.19,1146.32 -50.81,21.47 -1.32,14.24 6.56,35.98 50.77,-16.3 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3780"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3601.4,1070.46)",
    id: "g3786"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 5004.1,1172.33 7.03,46.2 -72.16,95.85 -17.71,-23.71 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3784"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3601.4,1070.46)",
    id: "g3790"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 5065.39,1211.06 -51.24,11.12 -71.35,90.66 43.32,26.27 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3788"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g3794"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1076.58,1356.93 c 0,0 73.68,47.12 -135.936,69.83 63.946,0 16.092,16.51 16.092,16.51 35.626,11.94 321.904,-41.23 146.474,-100.03 -24.21,2.12 -26.63,13.69 -26.63,13.69 z",
    id: "path3792"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g3798"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1164.54,1400.76 -0.25,33.39 c 0,0 -14.37,45.99 -214.004,62.45 201.094,-8.87 304.594,-61.44 214.254,-95.84 z",
    id: "path3796"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g3802"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 662.893,1347.1 c -52.88,9.83 -137.824,79.66 223.717,97.86",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: "2.92px"
    },
    id: "path3800"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g3806"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 696.101,1363.16 c 0,0 27.892,38.44 190.509,31.07",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px"
    },
    id: "path3804"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g3810"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 955.91,929.146 c 0,0 17.643,83.824 -46.919,138.044 31.389,-15.7 73.315,-53.27 73.315,-53.27 L 955.91,929.146",
    id: "path3808"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g3814"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 903.809,1252.84 31.667,27.89 66.954,-264.48 -52.609,38.63 c 0,0 54.139,-32.17 27.27,23.72 -33.904,145.99 -41.095,164.9 -41.095,164.9 0,0 -12.551,10.7 -23.185,-2.53 -6.83,-40.48 -9.54,3.27 -9.002,11.87 z",
    id: "path3812"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g3818"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 725.665,1311.77 c 0,0 56.986,68.07 149.942,27.34 -33.059,-26.12 -100.023,-31.6 -100.023,-31.6 z",
    style: {
      fill: "#ffffff",
      stroke: "#ffffff",
      strokeWidth: 5
    },
    id: "path3816"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g3822"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 885.431,1329.81 c 0,0 -8.961,22.57 -21.818,25.69 -12.857,3.11 182.257,-3.4 166.367,-16.39 -15.89,-12.99 -68.215,-24.91 -68.215,-24.91 0,0 -47.503,34.67 -76.334,15.61 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3820"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g3826"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 820.597,1176.4 c 0,0 129.369,142.19 73.763,152.45 -13.621,15 -24.897,27.42 -24.897,27.42 l 118.786,-6.71 c 0,0 -146.608,-151.42 -167.652,-173.16 z",
    id: "path3824"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g3830"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1048.74,1228.74 c 0,0 37.73,-19.56 7.03,14.61 -30.7,34.17 -67.521,85.93 -67.521,85.93 0,0 -10.152,-14.41 -26.882,-14.9 23.406,19.25 26.882,32.94 26.882,32.94 l 38.761,-6.94 -19.25,-11.27 74.33,-115.74 z",
    id: "path3828"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g3834"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 737.796,1213.37 35.464,25.7 92.62,100.04 -78.503,-104.18 z",
    id: "path3832"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g3838"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 725.665,1293.72 c 0,0 4.152,72.7 133.922,48.2 -49.673,-17.88 -87.126,10.18 -133.922,-48.2 z",
    id: "path3836"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g3842"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 719.256,1128.59 c 0,0 5.973,-26.25 28.646,-7.45 22.674,18.81 59.89,28.99 37.952,76.78 1.567,7.06 -19.979,-1.56 -19.979,-1.56 l 26.751,14.89 13.819,-58.94 -76.611,-54.56 z",
    id: "path3840"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g3846"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 817.562,1020.87 11.032,35.1 c 0,0 90.22,25.57 49.121,112.82 -4.994,21.57 -18.128,-2 -18.128,-2 l 33.192,64.69 9.317,-144.42 z",
    id: "path3844"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g3850"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1054.64,1160.19 c 0,0 34.98,9.68 -16.69,51.06 33.06,-13.19 42.36,-13.51 42.36,-13.51 l -4.17,-45.43 z",
    id: "path3848"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g3854"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 902.096,823.676 c 0,0 -218.981,-39.028 -294.193,207.534 -41.72,214.57 110.188,306.84 193.623,323.06",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 5
    },
    id: "path3852"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g3858"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 881.214,782.883 c 0,0 188.916,-6.076 278.436,179.557 79.22,164.27 -15.76,327.41 -88.5,391.83",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 5
    },
    id: "path3856"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3863"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 912.452,791.799 C 679.404,750.912 448.466,1039.38 635.904,1292.6",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "16.96px"
    },
    id: "path3861"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3867"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 893.339,816.753 C 1115.77,837.677 1294.6,1145.56 1030.16,1333.72",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "16.96px"
    },
    id: "path3865"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3871"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 778.378,879.072 21.174,16.542 c 0,0 -110.499,110.776 -97.266,136.306 -21.173,-34.029 -63.52,0 -63.52,0 0,0 46.892,-132.336 139.612,-152.848 z",
    style: {
      fill: "#ffffff",
      stroke: "#000000",
      strokeWidth: 5
    },
    id: "path3869"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3875"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 862.756,829.94 c 0,0 113.842,-9.768 195.014,48.501 -51.29,-61.688 -180.055,-72.752 -180.055,-72.752 0,0 -11.79,18.525 -14.959,24.251 z",
    id: "path3873"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3879"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 630.816,1298.97 c 0,0 58.058,63.81 97.72,72.72 -52.886,-30.54 -60.943,-46.27 -85.648,-84.5 -19.544,-22.71 -12.072,11.78 -12.072,11.78",
    style: {
      fill: "#ffffff"
    },
    id: "path3877"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrystalisation);
export default __webpack_public_path__ + "static/media/crystalisation.6b77a3e9760634b10de63d755f25fee1.svg";
export { ForwardRef as ReactComponent };